module.exports = __webpack_public_path__ + "static/img/3.83d30e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/eng/3.png
// module id = sTkh
// module chunks = 0